import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter, Route, Routes, Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './components/store';
import SignUp from './components/auth/SignUp';
import SignIn from './components/auth/SignIn';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Sidebar from './components/layout/Sidebar';
import VerifyYourEmail from './components/auth/VerifyYourEmail';
import ProtectedRoute from './routes/ProtectedRoute';
import PublicRoute from './routes/PublicRoute';
import ThankyouResetPassword from './components/auth/ThankyouResetPassword';
import NotFound from './components/pages/NotFound';
import Thankyou from './components/auth/Thankyou';
import ResellerHome from './components/reseller/ResellerHome';
import ResellerDetails from './components/reseller/ResellerDetails';
import ResellerCart from './components/reseller/ResellerCart';
import ResellerOrders from './components/reseller/ResellerOrders';
import OrderDetailsView from './components/reseller/OrderDetailsView';
import AdminSignIn from './components/auth/AdminSignIn';
import ClientList from './components/admin/ClientList';
import AdminProtectedRoute from './routes/AdminProtectedRoute';
import AdminPublicRoute from './routes/AdminPublicRoute';
import AdminSidebar from './components/layout/AdminSidebar';
import WalletReport from './components/admin/WalletReport';
import GiftCardOrder from './components/giftCard/GiftCardOrder';
import AllGiftCard from './components/giftCard/AllGiftCard';
import GiftCard from './components/giftCard/GiftCard';
import AdminNotFound from './components/pages/AdminNotFound';

const App = () => {
	const SidebarLayout = () => (
		<Sidebar>
			<Outlet />
		</Sidebar>
	);

	const AdminSidebarLayout = () => (
		<AdminSidebar>
			<Outlet />
		</AdminSidebar>
	);

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Routes>
					<Route element={<SidebarLayout />}>
						<Route
							path='/reseller-home'
							element={
								<ProtectedRoute>
									<ResellerHome />
								</ProtectedRoute>
							}
						/>

						<Route
							path='/reseller-details'
							element={
								<ProtectedRoute>
									<ResellerDetails />
								</ProtectedRoute>
							}
						/>

						<Route
							path='/reseller-cart'
							element={
								<ProtectedRoute>
									<ResellerCart />
								</ProtectedRoute>
							}
						/>

						<Route
							path='/reseller-orders'
							element={
								<ProtectedRoute>
									<ResellerOrders />
								</ProtectedRoute>
							}
						/>

						<Route
							path='/my_order_details'
							element={
								<ProtectedRoute>
									<OrderDetailsView />
								</ProtectedRoute>
							}
						/>

						<Route
							path='*'
							element={
								<ProtectedRoute>
									<NotFound />
								</ProtectedRoute>
							}
						/>
					</Route>

					<Route element={<AdminSidebarLayout />}>
						<Route
							path='/admin/wallet-report'
							element={
								<AdminProtectedRoute>
									<WalletReport />
								</AdminProtectedRoute>
							}
						/>

						<Route
							path='/admin/gift-cardOrder'
							element={
								<AdminProtectedRoute>
									<GiftCardOrder />
								</AdminProtectedRoute>
							}
						/>

						<Route
							path='/admin/gift-card'
							element={
								<AdminProtectedRoute>
									<AllGiftCard />
								</AdminProtectedRoute>
							}
						/>

						<Route
							path='/admin/gift-card-update'
							element={
								<AdminProtectedRoute>
									<GiftCard />
								</AdminProtectedRoute>
							}
						/>
						{/* <Route
                            path="*"
                            element={
                                <AdminProtectedRoute>
                                    <AdminNotFound />
                                </AdminProtectedRoute>
                            }
                        /> */}
					</Route>

					<Route
						path='/'
						element={
							<PublicRoute>
								<SignIn />
							</PublicRoute>
						}
					/>

					<Route
						path='/signin'
						element={
							<PublicRoute>
								<SignIn />
							</PublicRoute>
						}
					/>

					<Route
						path='/signup'
						element={
							<PublicRoute>
								<SignUp />
							</PublicRoute>
						}
					/>

					<Route
						path='/admin/client-list'
						element={
							<AdminProtectedRoute>
								<ClientList />
							</AdminProtectedRoute>
						}
					/>

					<Route
						path='/admin'
						element={
							<AdminPublicRoute>
								<AdminSignIn />
							</AdminPublicRoute>
						}
					/>

					<Route
						path='/forgot-password'
						element={
							<PublicRoute>
								<ForgotPassword />
							</PublicRoute>
						}
					/>

					<Route
						path='/reset-password'
						element={
							<PublicRoute>
								<ResetPassword />
							</PublicRoute>
						}
					/>

					<Route
						path='/thankyou'
						element={
							<PublicRoute>
								<Thankyou />
							</PublicRoute>
						}
					/>

					<Route
						path='/reset-thankyou'
						element={
							<PublicRoute>
								<ThankyouResetPassword />
							</PublicRoute>
						}
					/>

					<Route
						path='/verify-your-email'
						element={
							<PublicRoute>
								<VerifyYourEmail />
							</PublicRoute>
						}
					/>
				</Routes>
			</BrowserRouter>
		</Provider>
	);
};

export default App;
